import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { getFirebaseTimestamp, projectLastModified } from "@config/firestore";
import { UPDATE_PROJECT_LAST_MODIFIED_LOCALLY } from "./types";
export var updateProjectLastModified = /*#__PURE__*/ function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(projectUid) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1)
                switch (_context.prev = _context.next) {
                    case 0:
                        setDoc(doc(projectLastModified, projectUid), {
                            timestamp: getFirebaseTimestamp()
                        }, {
                            merge: true
                        });
                    case 1:
                    case "end":
                        return _context.stop();
                }
        }, _callee);
    }));
    return function updateProjectLastModified(_x) {
        return _ref.apply(this, arguments);
    };
}();
export var updateProjectLastModifiedLocally = function updateProjectLastModifiedLocally(projectUid, timestamp) {
    return {
        type: UPDATE_PROJECT_LAST_MODIFIED_LOCALLY,
        projectUid: projectUid,
        timestamp: timestamp
    };
};
export var getProjectLastModifiedOnce = function getProjectLastModifiedOnce(projectUid) {
    return /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(dispatch) {
            var timestampReference, timestampData, timestamp;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1)
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return getDoc(doc(projectLastModified, projectUid));
                        case 2:
                            timestampReference = _context2.sent;
                            timestampData = timestampReference.data();
                            timestamp = timestampData && timestampData.timestamp.toMillis();
                            _context2.next = 7;
                            return dispatch(updateProjectLastModifiedLocally(projectUid, timestamp));
                        case 7:
                            return _context2.abrupt("return", _context2.sent);
                        case 8:
                        case "end":
                            return _context2.stop();
                    }
            }, _callee2);
        }));
        return function (_x2) {
            return _ref2.apply(this, arguments);
        };
    }();
};
